export interface CountryObject {
  name: string;
  code: string;
  flag: string;
  dial_code: string;
  currency_code: string;
  time_zones: string[];
}

export const COUNTRIES_DATA: CountryObject[] = [
  {
    name: 'Afghanistan',
    flag: '🇦🇫',
    code: 'AF',
    dial_code: '+93',
    currency_code: 'AFN',
    time_zones: ['asia/kabul'],
  },
  {
    name: 'Åland Islands',
    flag: '🇦🇽',
    code: 'AX',
    dial_code: '+358',
    currency_code: 'EUR',
    time_zones: ['europe/mariehamn'],
  },
  {
    name: 'Albania',
    flag: '🇦🇱',
    code: 'AL',
    dial_code: '+355',
    currency_code: 'ALL',
    time_zones: ['europe/tirane'],
  },
  {
    name: 'Algeria',
    flag: '🇩🇿',
    code: 'DZ',
    dial_code: '+213',
    currency_code: 'DZD',
    time_zones: ['africa/algiers'],
  },
  {
    name: 'American Samoa',
    flag: '🇦🇸',
    code: 'AS',
    dial_code: '+1684',
    currency_code: 'USD',
    time_zones: ['pacific/pago_pago'],
  },
  {
    name: 'Andorra',
    flag: '🇦🇩',
    code: 'AD',
    dial_code: '+376',
    currency_code: 'EUR',
    time_zones: ['europe/andorra'],
  },
  {
    name: 'Angola',
    flag: '🇦🇴',
    code: 'AO',
    dial_code: '+244',
    currency_code: 'AOA',
    time_zones: ['africa/luanda'],
  },
  {
    name: 'Anguilla',
    flag: '🇦🇮',
    code: 'AI',
    dial_code: '+1264',
    currency_code: 'XCD',
    time_zones: ['america/anguilla'],
  },
  {
    name: 'Antarctica',
    flag: '🇦🇶',
    code: 'AQ',
    dial_code: '+672',
    currency_code: 'N/A',
    time_zones: [
      'antarctica/casey',
      'antarctica/davis',
      'antarctica/mawson',
      'antarctica/palmer',
      'antarctica/rothera',
      'antarctica/syowa',
      'antarctica/troll',
      'antarctica/vostok',
    ],
  },
  {
    name: 'Antigua and Barbuda',
    flag: '🇦🇬',
    code: 'AG',
    dial_code: '+1268',
    currency_code: 'XCD',
    time_zones: ['america/antigua'],
  },
  {
    name: 'Argentina',
    flag: '🇦🇷',
    code: 'AR',
    dial_code: '+54',
    currency_code: 'ARS',
    time_zones: ['america/argentina/buenos_aires'],
  },
  {
    name: 'Armenia',
    flag: '🇦🇲',
    code: 'AM',
    dial_code: '+374',
    currency_code: 'AMD',
    time_zones: ['asia/yerevan'],
  },
  {
    name: 'Aruba',
    flag: '🇦🇼',
    code: 'AW',
    dial_code: '+297',
    currency_code: 'AWG',
    time_zones: ['america/aruba'],
  },
  {
    name: 'Australia',
    flag: '🇦🇺',
    code: 'AU',
    dial_code: '+61',
    currency_code: 'AUD',
    time_zones: [
      'australia/sydney',
      'australia/perth',
      'australia/adelaide',
      'australia/darwin',
      'australia/melbourne',
    ],
  },
  {
    name: 'Austria',
    flag: '🇦🇹',
    code: 'AT',
    dial_code: '+43',
    currency_code: 'EUR',
    time_zones: ['europe/vienna'],
  },
  {
    name: 'Azerbaijan',
    flag: '🇦🇿',
    code: 'AZ',
    dial_code: '+994',
    currency_code: 'AZN',
    time_zones: ['asia/baku'],
  },
  {
    name: 'Bahamas',
    flag: '🇧🇸',
    code: 'BS',
    dial_code: '+1242',
    currency_code: 'BSD',
    time_zones: ['america/nassau'],
  },
  {
    name: 'Bahrain',
    flag: '🇧🇭',
    code: 'BH',
    dial_code: '+973',
    currency_code: 'BHD',
    time_zones: ['asia/bahrain'],
  },
  {
    name: 'Bangladesh',
    flag: '🇧🇩',
    code: 'BD',
    dial_code: '+880',
    currency_code: 'BDT',
    time_zones: ['asia/dhaka'],
  },
  {
    name: 'Barbados',
    flag: '🇧🇧',
    code: 'BB',
    dial_code: '+1246',
    currency_code: 'BBD',
    time_zones: ['america/barbados'],
  },
  {
    name: 'Belarus',
    flag: '🇧🇾',
    code: 'BY',
    dial_code: '+375',
    currency_code: 'BYN',
    time_zones: ['europe/minsk'],
  },
  {
    name: 'Belgium',
    flag: '🇧🇪',
    code: 'BE',
    dial_code: '+32',
    currency_code: 'EUR',
    time_zones: ['europe/brussels'],
  },
  {
    name: 'Belize',
    flag: '🇧🇿',
    code: 'BZ',
    dial_code: '+501',
    currency_code: 'BZD',
    time_zones: ['america/belize'],
  },
  {
    name: 'Benin',
    flag: '🇧🇯',
    code: 'BJ',
    dial_code: '+229',
    currency_code: 'XOF',
    time_zones: ['africa/porto-novo'],
  },
  {
    name: 'Bermuda',
    flag: '🇧🇲',
    code: 'BM',
    dial_code: '+1441',
    currency_code: 'BMD',
    time_zones: ['atlantic/bermuda'],
  },
  {
    name: 'Bhutan',
    flag: '🇧🇹',
    code: 'BT',
    dial_code: '+975',
    currency_code: 'BTN',
    time_zones: ['asia/thimphu'],
  },
  {
    name: 'Bolivia',
    flag: '🇧🇴',
    code: 'BO',
    dial_code: '+591',
    currency_code: 'BOB',
    time_zones: ['america/la_paz'],
  },
  {
    name: 'Bosnia and Herzegovina',
    flag: '🇧🇦',
    code: 'BA',
    dial_code: '+387',
    currency_code: 'BAM',
    time_zones: ['europe/sarajevo'],
  },
  {
    name: 'Botswana',
    flag: '🇧🇼',
    code: 'BW',
    dial_code: '+267',
    currency_code: 'BWP',
    time_zones: ['africa/gaborone'],
  },
  {
    name: 'Bouvet Island',
    flag: '🇧🇻',
    code: 'BV',
    dial_code: '+47',
    currency_code: 'NOK',
    time_zones: ['antarctica/bouvet'],
  },
  {
    name: 'Brazil',
    flag: '🇧🇷',
    code: 'BR',
    dial_code: '+55',
    currency_code: 'BRL',
    time_zones: [
      'america/sao_paulo',
      'america/manaus',
      'america/fortaleza',
      'america/cuiaba',
    ],
  },
  {
    name: 'British Indian Ocean Territory',
    flag: '🇮🇴',
    code: 'IO',
    dial_code: '+246',
    currency_code: 'USD',
    time_zones: ['Indian/Chagos'],
  },
  {
    name: 'Brunei Darussalam',
    flag: '🇧🇳',
    code: 'BN',
    dial_code: '+673',
    currency_code: 'BND',
    time_zones: ['Asia/Brunei'],
  },
  {
    name: 'Bulgaria',
    flag: '🇧🇬',
    code: 'BG',
    dial_code: '+359',
    currency_code: 'BGN',
    time_zones: ['Europe/Sofia'],
  },
  {
    name: 'Burkina Faso',
    flag: '🇧🇫',
    code: 'BF',
    dial_code: '+226',
    currency_code: 'XOF',
    time_zones: ['Africa/Ouagadougou'],
  },
  {
    name: 'Burundi',
    flag: '🇧🇮',
    code: 'BI',
    dial_code: '+257',
    currency_code: 'BIF',
    time_zones: ['Africa/Bujumbura'],
  },
  {
    name: 'Cambodia',
    flag: '🇰🇭',
    code: 'KH',
    dial_code: '+855',
    currency_code: 'KHR',
    time_zones: ['Asia/Phnom_Penh'],
  },
  {
    name: 'Cameroon',
    flag: '🇨🇲',
    code: 'CM',
    dial_code: '+237',
    currency_code: 'XAF',
    time_zones: ['Africa/Douala'],
  },
  {
    name: 'Canada',
    flag: '🇨🇦',
    code: 'CA',
    dial_code: '+1',
    currency_code: 'CAD',
    time_zones: [
      'America/Toronto',
      'America/Vancouver',
      'America/Edmonton',
      'America/Winnipeg',
      'America/Halifax',
      'America/St_Johns',
    ],
  },
  {
    name: 'Cape Verde',
    flag: '🇨🇻',
    code: 'CV',
    dial_code: '+238',
    currency_code: 'CVE',
    time_zones: ['Atlantic/Cape_Verde'],
  },
  {
    name: 'Cayman Islands',
    flag: '🇰🇾',
    code: 'KY',
    dial_code: '+1345',
    currency_code: 'KYD',
    time_zones: ['America/Cayman'],
  },
  {
    name: 'Central African Republic',
    flag: '🇨🇫',
    code: 'CF',
    dial_code: '+236',
    currency_code: 'XAF',
    time_zones: ['Africa/Bangui'],
  },
  {
    name: 'Chad',
    flag: '🇹🇩',
    code: 'TD',
    dial_code: '+235',
    currency_code: 'XAF',
    time_zones: ['Africa/Ndjamena'],
  },
  {
    name: 'Chile',
    flag: '🇨🇱',
    code: 'CL',
    dial_code: '+56',
    currency_code: 'CLP',
    time_zones: ['America/Santiago', 'Pacific/Easter'],
  },
  {
    name: 'China',
    flag: '🇨🇳',
    code: 'CN',
    dial_code: '+86',
    currency_code: 'CNY',
    time_zones: ['Asia/Shanghai'],
  },
  {
    name: 'Christmas Island',
    flag: '🇨🇽',
    code: 'CX',
    dial_code: '+61',
    currency_code: 'AUD',
    time_zones: ['Indian/Christmas'],
  },
  {
    name: 'Cocos (Keeling) Islands',
    flag: '🇨🇨',
    code: 'CC',
    dial_code: '+61',
    currency_code: 'AUD',
    time_zones: ['Indian/Cocos'],
  },
  {
    name: 'Colombia',
    flag: '🇨🇴',
    code: 'CO',
    dial_code: '+57',
    currency_code: 'COP',
    time_zones: ['America/Bogota'],
  },
  {
    name: 'Comoros',
    flag: '🇰🇲',
    code: 'KM',
    dial_code: '+269',
    currency_code: 'KMF',
    time_zones: ['Indian/Comoro'],
  },
  {
    name: 'Congo',
    flag: '🇨🇬',
    code: 'CG',
    dial_code: '+242',
    currency_code: 'XAF',
    time_zones: ['Africa/Brazzaville'],
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    flag: '🇨🇩',
    code: 'CD',
    dial_code: '+243',
    currency_code: 'CDF',
    time_zones: ['Africa/Kinshasa', 'Africa/Lubumbashi'],
  },
  {
    name: 'Cook Islands',
    flag: '🇨🇰',
    code: 'CK',
    dial_code: '+682',
    currency_code: 'NZD',
    time_zones: ['Pacific/Rarotonga'],
  },
  {
    name: 'Costa Rica',
    flag: '🇨🇷',
    code: 'CR',
    dial_code: '+506',
    currency_code: 'CRC',
    time_zones: ['America/Costa_Rica'],
  },
  {
    name: "Côte d'Ivoire",
    flag: '🇨🇮',
    code: 'CI',
    dial_code: '+225',
    currency_code: 'XOF',
    time_zones: ['Africa/Abidjan'],
  },
  {
    name: 'Croatia',
    flag: '🇭🇷',
    code: 'HR',
    dial_code: '+385',
    currency_code: 'HRK',
    time_zones: ['Europe/Zagreb'],
  },
  {
    name: 'Cuba',
    flag: '🇨🇺',
    code: 'CU',
    dial_code: '+53',
    currency_code: 'CUP',
    time_zones: ['America/Havana'],
  },
  {
    name: 'Cyprus',
    flag: '🇨🇾',
    code: 'CY',
    dial_code: '+357',
    currency_code: 'EUR',
    time_zones: ['Asia/Nicosia'],
  },
  {
    name: 'Czech Republic',
    flag: '🇨🇿',
    code: 'CZ',
    dial_code: '+420',
    currency_code: 'CZK',
    time_zones: ['Europe/Prague'],
  },
  {
    name: 'Denmark',
    flag: '🇩🇰',
    code: 'DK',
    dial_code: '+45',
    currency_code: 'DKK',
    time_zones: ['Europe/Copenhagen'],
  },
  {
    name: 'Djibouti',
    flag: '🇩🇯',
    code: 'DJ',
    dial_code: '+253',
    currency_code: 'DJF',
    time_zones: ['Africa/Djibouti'],
  },
  {
    name: 'Dominica',
    flag: '🇩🇲',
    code: 'DM',
    dial_code: '+1767',
    currency_code: 'XCD',
    time_zones: ['America/Dominica'],
  },
  {
    name: 'Dominican Republic',
    flag: '🇩🇴',
    code: 'DO',
    dial_code: '+1849',
    currency_code: 'DOP',
    time_zones: ['America/Santo_Domingo'],
  },
  {
    name: 'Ecuador',
    flag: '🇪🇨',
    code: 'EC',
    dial_code: '+593',
    currency_code: 'USD',
    time_zones: ['America/Guayaquil', 'Pacific/Galapagos'],
  },
  {
    name: 'Egypt',
    flag: '🇪🇬',
    code: 'EG',
    dial_code: '+20',
    currency_code: 'EGP',
    time_zones: ['Africa/Cairo'],
  },
  {
    name: 'El Salvador',
    flag: '🇸🇻',
    code: 'SV',
    dial_code: '+503',
    currency_code: 'SVC',
    time_zones: ['America/El_Salvador'],
  },
  {
    name: 'Equatorial Guinea',
    flag: '🇬🇶',
    code: 'GQ',
    dial_code: '+240',
    currency_code: 'XAF',
    time_zones: ['Africa/Malabo'],
  },
  {
    name: 'Eritrea',
    flag: '🇪🇷',
    code: 'ER',
    dial_code: '+291',
    currency_code: 'ERN',
    time_zones: ['Africa/Asmara'],
  },
  {
    name: 'Estonia',
    flag: '🇪🇪',
    code: 'EE',
    dial_code: '+372',
    currency_code: 'EUR',
    time_zones: ['Europe/Tallinn'],
  },
  {
    name: 'Ethiopia',
    flag: '🇪🇹',
    code: 'ET',
    dial_code: '+251',
    currency_code: 'ETB',
    time_zones: ['Africa/Addis_Ababa'],
  },
  {
    name: 'Falkland Islands (Malvinas)',
    flag: '🇫🇰',
    code: 'FK',
    dial_code: '+500',
    currency_code: 'FKP',
    time_zones: ['Atlantic/Stanley'],
  },
  {
    name: 'Faroe Islands',
    flag: '🇫🇴',
    code: 'FO',
    dial_code: '+298',
    currency_code: 'DKK',
    time_zones: ['Atlantic/Faroe'],
  },
  {
    name: 'Fiji',
    flag: '🇫🇯',
    code: 'FJ',
    dial_code: '+679',
    currency_code: 'FJD',
    time_zones: ['Pacific/Fiji'],
  },
  {
    name: 'Finland',
    flag: '🇫🇮',
    code: 'FI',
    dial_code: '+358',
    currency_code: 'EUR',
    time_zones: ['Europe/Helsinki'],
  },
  {
    name: 'France',
    flag: '🇫🇷',
    code: 'FR',
    dial_code: '+33',
    currency_code: 'EUR',
    time_zones: ['Europe/Paris'],
  },
  {
    name: 'French Guiana',
    flag: '🇬🇫',
    code: 'GF',
    dial_code: '+594',
    currency_code: 'EUR',
    time_zones: ['America/Cayenne'],
  },
  {
    name: 'French Polynesia',
    flag: '🇵🇫',
    code: 'PF',
    dial_code: '+689',
    currency_code: 'XPF',
    time_zones: ['Pacific/Tahiti'],
  },
  {
    name: 'French Southern Territories',
    flag: '🇹🇫',
    code: 'TF',
    dial_code: '+262',
    currency_code: 'EUR',
    time_zones: ['Indian/Kerguelen'],
  },
  {
    name: 'Gabon',
    flag: '🇬🇦',
    code: 'GA',
    dial_code: '+241',
    currency_code: 'XAF',
    time_zones: ['Africa/Libreville'],
  },
  {
    name: 'Gambia',
    flag: '🇬🇲',
    code: 'GM',
    dial_code: '+220',
    currency_code: 'GMD',
    time_zones: ['Africa/Banjul'],
  },
  {
    name: 'Georgia',
    flag: '🇬🇪',
    code: 'GE',
    dial_code: '+995',
    currency_code: 'GEL',
    time_zones: ['Asia/Tbilisi'],
  },
  {
    name: 'Germany',
    flag: '🇩🇪',
    code: 'DE',
    dial_code: '+49',
    currency_code: 'EUR',
    time_zones: ['Europe/Berlin'],
  },
  {
    name: 'Ghana',
    flag: '🇬🇭',
    code: 'GH',
    dial_code: '+233',
    currency_code: 'GHS',
    time_zones: ['Africa/Accra'],
  },
  {
    name: 'Gibraltar',
    flag: '🇬🇮',
    code: 'GI',
    dial_code: '+350',
    currency_code: 'GIP',
    time_zones: ['Europe/Gibraltar'],
  },
  {
    name: 'Greece',
    flag: '🇬🇷',
    code: 'GR',
    dial_code: '+30',
    currency_code: 'EUR',
    time_zones: ['Europe/Athens'],
  },
  {
    name: 'Greenland',
    flag: '🇬🇱',
    code: 'GL',
    dial_code: '+299',
    currency_code: 'DKK',
    time_zones: [
      'America/Godthab',
      'America/Danmarkshavn',
      'America/Scoresbysund',
      'America/Thule',
    ],
  },
  {
    name: 'Grenada',
    flag: '🇬🇩',
    code: 'GD',
    dial_code: '+1473',
    currency_code: 'XCD',
    time_zones: ['America/Grenada'],
  },
  {
    name: 'Guadeloupe',
    flag: '🇬🇵',
    code: 'GP',
    dial_code: '+590',
    currency_code: 'EUR',
    time_zones: ['America/Guadeloupe'],
  },
  {
    name: 'Guam',
    flag: '🇬🇺',
    code: 'GU',
    dial_code: '+1671',
    currency_code: 'USD',
    time_zones: ['Pacific/Guam'],
  },
  {
    name: 'Guatemala',
    flag: '🇬🇹',
    code: 'GT',
    dial_code: '+502',
    currency_code: 'GTQ',
    time_zones: ['America/Guatemala'],
  },
  {
    name: 'Guernsey',
    flag: '🇬🇬',
    code: 'GG',
    dial_code: '+44',
    currency_code: 'GBP',
    time_zones: ['Europe/Guernsey'],
  },
  {
    name: 'Guinea',
    flag: '🇬🇳',
    code: 'GN',
    dial_code: '+224',
    currency_code: 'GNF',
    time_zones: ['Africa/Conakry'],
  },
  {
    name: 'Guinea-Bissau',
    flag: '🇬🇼',
    code: 'GW',
    dial_code: '+245',
    currency_code: 'XOF',
    time_zones: ['Africa/Bissau'],
  },
  {
    name: 'Guyana',
    flag: '🇬🇾',
    code: 'GY',
    dial_code: '+592',
    currency_code: 'GYD',
    time_zones: ['America/Guyana'],
  },
  {
    name: 'Haiti',
    flag: '🇭🇹',
    code: 'HT',
    dial_code: '+509',
    currency_code: 'HTG',
    time_zones: ['America/Port-au-Prince'],
  },
  {
    name: 'Heard Island and Mcdonald Islands',
    flag: '🇭🇲',
    code: 'HM',
    dial_code: '+672',
    currency_code: 'AUD',
    time_zones: ['Indian/Heard'],
  },
  {
    name: 'Holy See (Vatican City State)',
    flag: '🇻🇦',
    code: 'VA',
    dial_code: '+379',
    currency_code: 'EUR',
    time_zones: ['Europe/Vatican'],
  },
  {
    name: 'Honduras',
    flag: '🇭🇳',
    code: 'HN',
    dial_code: '+504',
    currency_code: 'HNL',
    time_zones: ['America/Tegucigalpa'],
  },
  {
    name: 'Hong Kong',
    flag: '🇭🇰',
    code: 'HK',
    dial_code: '+852',
    currency_code: 'HKD',
    time_zones: ['Asia/Hong_Kong'],
  },
  {
    name: 'Hungary',
    flag: '🇭🇺',
    code: 'HU',
    dial_code: '+36',
    currency_code: 'HUF',
    time_zones: ['Europe/Budapest'],
  },
  {
    name: 'Iceland',
    flag: '🇮🇸',
    code: 'IS',
    dial_code: '+354',
    currency_code: 'ISK',
    time_zones: ['Atlantic/Reykjavik'],
  },
  {
    name: 'India',
    flag: '🇮🇳',
    code: 'IN',
    dial_code: '+91',
    currency_code: 'INR',
    time_zones: ['Asia/Kolkata'],
  },
  {
    name: 'Indonesia',
    flag: '🇮🇩',
    code: 'ID',
    dial_code: '+62',
    currency_code: 'IDR',
    time_zones: [
      'Asia/Jakarta',
      'Asia/Pontianak',
      'Asia/Makassar',
      'Asia/Jayapura',
    ],
  },
  {
    name: 'Iran',
    flag: '🇮🇷',
    code: 'IR',
    dial_code: '+98',
    currency_code: 'IRR',
    time_zones: ['Asia/Tehran'],
  },
  {
    name: 'Iraq',
    flag: '🇮🇶',
    code: 'IQ',
    dial_code: '+964',
    currency_code: 'IQD',
    time_zones: ['Asia/Baghdad'],
  },
  {
    name: 'Ireland',
    flag: '🇮🇪',
    code: 'IE',
    dial_code: '+353',
    currency_code: 'EUR',
    time_zones: ['Europe/Dublin'],
  },
  {
    name: 'Isle of Man',
    flag: '🇮🇲',
    code: 'IM',
    dial_code: '+44',
    currency_code: 'GBP',
    time_zones: ['Europe/Isle_of_Man'],
  },
  {
    name: 'Israel',
    flag: '🇮🇱',
    code: 'IL',
    dial_code: '+972',
    currency_code: 'ILS',
    time_zones: ['Asia/Jerusalem'],
  },
  {
    name: 'Italy',
    flag: '🇮🇹',
    code: 'IT',
    dial_code: '+39',
    currency_code: 'EUR',
    time_zones: ['Europe/Rome'],
  },
  {
    name: 'Jamaica',
    flag: '🇯🇲',
    code: 'JM',
    dial_code: '+1876',
    currency_code: 'JMD',
    time_zones: ['America/Jamaica'],
  },
  {
    name: 'Japan',
    flag: '🇯🇵',
    code: 'JP',
    dial_code: '+81',
    currency_code: 'JPY',
    time_zones: ['Asia/Tokyo'],
  },
  {
    name: 'Jersey',
    flag: '🇯🇪',
    code: 'JE',
    dial_code: '+44',
    currency_code: 'GBP',
    time_zones: ['Europe/Jersey'],
  },
  {
    name: 'Jordan',
    flag: '🇯🇴',
    code: 'JO',
    dial_code: '+962',
    currency_code: 'JOD',
    time_zones: ['Asia/Amman'],
  },
  {
    name: 'Kazakhstan',
    flag: '🇰🇿',
    code: 'KZ',
    dial_code: '+7',
    currency_code: 'KZT',
    time_zones: [
      'Asia/Almaty',
      'Asia/Aqtobe',
      'Asia/Aqtau',
      'Asia/Oral',
      'Asia/Qyzylorda',
      'Asia/Atyrau',
      'Asia/Sevastopol',
    ],
  },
  {
    name: 'Kenya',
    flag: '🇰🇪',
    code: 'KE',
    dial_code: '+254',
    currency_code: 'KES',
    time_zones: ['Africa/Nairobi'],
  },
  {
    name: 'Kiribati',
    flag: '🇰🇮',
    code: 'KI',
    dial_code: '+686',
    currency_code: 'AUD',
    time_zones: ['Pacific/Tarawa', 'Pacific/Kiritimati', 'Pacific/Enderbury'],
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    flag: '🇰🇵',
    code: 'KP',
    dial_code: '+850',
    currency_code: 'KPW',
    time_zones: ['Asia/Pyongyang'],
  },
  {
    name: 'Korea, Republic of South Korea',
    flag: '🇰🇷',
    code: 'KR',
    dial_code: '+82',
    currency_code: 'KRW',
    time_zones: ['Asia/Seoul'],
  },
  {
    name: 'Kosovo',
    flag: '🇽🇰',
    code: 'XK',
    dial_code: '+383',
    currency_code: 'EUR',
    time_zones: ['Europe/Belgrade'],
  },
  {
    name: 'Kuwait',
    flag: '🇰🇼',
    code: 'KW',
    dial_code: '+965',
    currency_code: 'KWD',
    time_zones: ['Asia/Kuwait'],
  },
  {
    name: 'Kyrgyzstan',
    flag: '🇰🇬',
    code: 'KG',
    dial_code: '+996',
    currency_code: 'KGS',
    time_zones: ['Asia/Bishkek'],
  },
  {
    name: 'Laos',
    flag: '🇱🇦',
    code: 'LA',
    dial_code: '+856',
    currency_code: 'LAK',
    time_zones: ['Asia/Vientiane'],
  },
  {
    name: 'Latvia',
    flag: '🇱🇻',
    code: 'LV',
    dial_code: '+371',
    currency_code: 'EUR',
    time_zones: ['Europe/Riga'],
  },
  {
    name: 'Lebanon',
    flag: '🇱🇧',
    code: 'LB',
    dial_code: '+961',
    currency_code: 'LBP',
    time_zones: ['Asia/Beirut'],
  },
  {
    name: 'Lesotho',
    flag: '🇱🇸',
    code: 'LS',
    dial_code: '+266',
    currency_code: 'LSL',
    time_zones: ['Africa/Maseru'],
  },
  {
    name: 'Liberia',
    flag: '🇱🇷',
    code: 'LR',
    dial_code: '+231',
    currency_code: 'LRD',
    time_zones: ['Africa/Monrovia'],
  },
  {
    name: 'Libyan Arab Jamahiriya',
    flag: '🇱🇾',
    code: 'LY',
    dial_code: '+218',
    currency_code: 'LYD',
    time_zones: ['Africa/Tripoli'],
  },
  {
    name: 'Liechtenstein',
    flag: '🇱🇮',
    code: 'LI',
    dial_code: '+423',
    currency_code: 'CHF',
    time_zones: ['Europe/Vaduz'],
  },
  {
    name: 'Lithuania',
    flag: '🇱🇹',
    code: 'LT',
    dial_code: '+370',
    currency_code: 'EUR',
    time_zones: ['Europe/Vilnius'],
  },
  {
    name: 'Luxembourg',
    flag: '🇱🇺',
    code: 'LU',
    dial_code: '+352',
    currency_code: 'EUR',
    time_zones: ['Europe/Luxembourg'],
  },
  {
    name: 'Macao',
    flag: '🇲🇴',
    code: 'MO',
    dial_code: '+853',
    currency_code: 'MOP',
    time_zones: ['Asia/Macau'],
  },
  {
    name: 'Macedonia',
    flag: '🇲🇰',
    code: 'MK',
    dial_code: '+389',
    currency_code: 'MKD',
    time_zones: ['Europe/Skopje'],
  },
  {
    name: 'Madagascar',
    flag: '🇲🇬',
    code: 'MG',
    dial_code: '+261',
    currency_code: 'MGA',
    time_zones: ['Indian/Antananarivo'],
  },
  {
    name: 'Malawi',
    flag: '🇲🇼',
    code: 'MW',
    dial_code: '+265',
    currency_code: 'MWK',
    time_zones: ['Africa/Blantyre'],
  },
  {
    name: 'Malaysia',
    flag: '🇲🇾',
    code: 'MY',
    dial_code: '+60',
    currency_code: 'MYR',
    time_zones: ['Asia/Kuala_Lumpur', 'Asia/Kuching'],
  },
  {
    name: 'Maldives',
    flag: '🇲🇻',
    code: 'MV',
    dial_code: '+960',
    currency_code: 'MVR',
    time_zones: ['Indian/Maldives'],
  },
  {
    name: 'Mali',
    flag: '🇲🇱',
    code: 'ML',
    dial_code: '+223',
    currency_code: 'XOF',
    time_zones: ['Africa/Bamako'],
  },
  {
    name: 'Malta',
    flag: '🇲🇹',
    code: 'MT',
    dial_code: '+356',
    currency_code: 'EUR',
    time_zones: ['Europe/Malta'],
  },
  {
    name: 'Marshall Islands',
    flag: '🇲🇭',
    code: 'MH',
    dial_code: '+692',
    currency_code: 'USD',
    time_zones: ['Pacific/Majuro', 'Pacific/Kwajalein'],
  },
  {
    name: 'Martinique',
    flag: '🇲🇶',
    code: 'MQ',
    dial_code: '+596',
    currency_code: 'EUR',
    time_zones: ['America/Martinique'],
  },
  {
    name: 'Mauritania',
    flag: '🇲🇷',
    code: 'MR',
    dial_code: '+222',
    currency_code: 'MRU',
    time_zones: ['Africa/Nouakchott'],
  },
  {
    name: 'Mauritius',
    flag: '🇲🇺',
    code: 'MU',
    dial_code: '+230',
    currency_code: 'MUR',
    time_zones: ['Indian/Mauritius'],
  },
  {
    name: 'Mayotte',
    flag: '🇾🇹',
    code: 'YT',
    dial_code: '+262',
    currency_code: 'EUR',
    time_zones: ['Indian/Mayotte'],
  },
  {
    name: 'Mexico',
    flag: '🇲🇽',
    code: 'MX',
    dial_code: '+52',
    currency_code: 'MXN',
    time_zones: [
      'America/Mexico_City',
      'America/Cancun',
      'America/Merida',
      'America/Monterrey',
      'America/Chihuahua',
      'America/Hermosillo',
      'America/Tijuana',
    ],
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    flag: '🇫🇲',
    code: 'FM',
    dial_code: '+691',
    currency_code: 'USD',
    time_zones: ['Pacific/Chuuk', 'Pacific/Pohnpei', 'Pacific/Kosrae'],
  },
  {
    name: 'Moldova',
    flag: '🇲🇩',
    code: 'MD',
    dial_code: '+373',
    currency_code: 'MDL',
    time_zones: ['Europe/Chisinau'],
  },
  {
    name: 'Monaco',
    flag: '🇲🇨',
    code: 'MC',
    dial_code: '+377',
    currency_code: 'EUR',
    time_zones: ['Europe/Monaco'],
  },
  {
    name: 'Mongolia',
    flag: '🇲🇳',
    code: 'MN',
    dial_code: '+976',
    currency_code: 'MNT',
    time_zones: ['Asia/Ulaanbaatar', 'Asia/Hovd', 'Asia/Choibalsan'],
  },
  {
    name: 'Montenegro',
    flag: '🇲🇪',
    code: 'ME',
    dial_code: '+382',
    currency_code: 'EUR',
    time_zones: ['Europe/Podgorica'],
  },
  {
    name: 'Montserrat',
    flag: '🇲🇸',
    code: 'MS',
    dial_code: '+1664',
    currency_code: 'XCD',
    time_zones: ['America/Montserrat'],
  },
  {
    name: 'Morocco',
    flag: '🇲🇦',
    code: 'MA',
    dial_code: '+212',
    currency_code: 'MAD',
    time_zones: ['Africa/Casablanca'],
  },
  {
    name: 'Mozambique',
    flag: '🇲🇿',
    code: 'MZ',
    dial_code: '+258',
    currency_code: 'MZN',
    time_zones: ['Africa/Maputo'],
  },
  {
    name: 'Myanmar',
    flag: '🇲🇲',
    code: 'MM',
    dial_code: '+95',
    currency_code: 'MMK',
    time_zones: ['Asia/Yangon'],
  },
  {
    name: 'Namibia',
    flag: '🇳🇦',
    code: 'NA',
    dial_code: '+264',
    currency_code: 'NAD',
    time_zones: ['Africa/Windhoek'],
  },
  {
    name: 'Nauru',
    flag: '🇳🇷',
    code: 'NR',
    dial_code: '+674',
    currency_code: 'AUD',
    time_zones: ['Pacific/Nauru'],
  },
  {
    name: 'Nepal',
    flag: '🇳🇵',
    code: 'NP',
    dial_code: '+977',
    currency_code: 'NPR',
    time_zones: ['Asia/Kathmandu'],
  },
  {
    name: 'Netherlands',
    flag: '🇳🇱',
    code: 'NL',
    dial_code: '+31',
    currency_code: 'EUR',
    time_zones: ['Europe/Amsterdam'],
  },
  {
    name: 'Netherlands Antilles',
    flag: '',
    code: 'AN',
    dial_code: '+599',
    currency_code: 'ANG',
    time_zones: ['America/Curacao'],
  },
  {
    name: 'New Caledonia',
    flag: '🇳🇨',
    code: 'NC',
    dial_code: '+687',
    currency_code: 'XPF',
    time_zones: ['Pacific/Noumea'],
  },
  {
    name: 'New Zealand',
    flag: '🇳🇿',
    code: 'NZ',
    dial_code: '+64',
    currency_code: 'NZD',
    time_zones: ['Pacific/Auckland', 'Pacific/Chatham'],
  },
  {
    name: 'Nicaragua',
    flag: '🇳🇮',
    code: 'NI',
    dial_code: '+505',
    currency_code: 'NIO',
    time_zones: ['America/Managua'],
  },
  {
    name: 'Niger',
    flag: '🇳🇪',
    code: 'NE',
    dial_code: '+227',
    currency_code: 'XOF',
    time_zones: ['Africa/Niamey'],
  },
  {
    name: 'Nigeria',
    flag: '🇳🇬',
    code: 'NG',
    dial_code: '+234',
    currency_code: 'NGN',
    time_zones: ['Africa/Lagos'],
  },
  {
    name: 'Niue',
    flag: '🇳🇺',
    code: 'NU',
    dial_code: '+683',
    currency_code: 'NZD',
    time_zones: ['Pacific/Niue'],
  },
  {
    name: 'Norfolk Island',
    flag: '🇳🇫',
    code: 'NF',
    dial_code: '+672',
    currency_code: 'AUD',
    time_zones: ['Pacific/Norfolk'],
  },
  {
    name: 'Northern Mariana Islands',
    flag: '🇲🇵',
    code: 'MP',
    dial_code: '+1670',
    currency_code: 'USD',
    time_zones: ['Pacific/Saipan'],
  },
  {
    name: 'Norway',
    flag: '🇳🇴',
    code: 'NO',
    dial_code: '+47',
    currency_code: 'NOK',
    time_zones: ['Europe/Oslo'],
  },
  {
    name: 'Oman',
    flag: '🇴🇲',
    code: 'OM',
    dial_code: '+968',
    currency_code: 'OMR',
    time_zones: ['Asia/Muscat'],
  },
  {
    name: 'Pakistan',
    flag: '🇵🇰',
    code: 'PK',
    dial_code: '+92',
    currency_code: 'PKR',
    time_zones: ['Asia/Karachi'],
  },
  {
    name: 'Palau',
    flag: '🇵🇼',
    code: 'PW',
    dial_code: '+680',
    currency_code: 'USD',
    time_zones: ['Pacific/Palau'],
  },
  {
    name: 'Palestinian Territory, Occupied',
    flag: '🇵🇸',
    code: 'PS',
    dial_code: '+970',
    currency_code: 'ILS',
    time_zones: ['Asia/Gaza', 'Asia/Hebron'],
  },
  {
    name: 'Panama',
    flag: '🇵🇦',
    code: 'PA',
    dial_code: '+507',
    currency_code: 'PAB',
    time_zones: ['America/Panama'],
  },
  {
    name: 'Papua New Guinea',
    flag: '🇵🇬',
    code: 'PG',
    dial_code: '+675',
    currency_code: 'PGK',
    time_zones: ['Pacific/Port_Moresby'],
  },
  {
    name: 'Paraguay',
    flag: '🇵🇾',
    code: 'PY',
    dial_code: '+595',
    currency_code: 'PYG',
    time_zones: ['America/Asuncion'],
  },
  {
    name: 'Peru',
    flag: '🇵🇪',
    code: 'PE',
    dial_code: '+51',
    currency_code: 'PEN',
    time_zones: ['America/Lima'],
  },
  {
    name: 'Philippines',
    flag: '🇵🇭',
    code: 'PH',
    dial_code: '+63',
    currency_code: 'PHP',
    time_zones: ['Asia/Manila'],
  },
  {
    name: 'Pitcairn',
    flag: '🇵🇳',
    code: 'PN',
    dial_code: '+64',
    currency_code: 'NZD',
    time_zones: ['Pacific/Pitcairn'],
  },
  {
    name: 'Poland',
    flag: '🇵🇱',
    code: 'PL',
    dial_code: '+48',
    currency_code: 'PLN',
    time_zones: ['Europe/Warsaw'],
  },
  {
    name: 'Portugal',
    flag: '🇵🇹',
    code: 'PT',
    dial_code: '+351',
    currency_code: 'EUR',
    time_zones: ['Europe/Lisbon', 'Atlantic/Madeira', 'Atlantic/Azores'],
  },
  {
    name: 'Puerto Rico',
    flag: '🇵🇷',
    code: 'PR',
    dial_code: '+1939',
    currency_code: 'USD',
    time_zones: ['America/Puerto_Rico'],
  },
  {
    name: 'Qatar',
    flag: '🇶🇦',
    code: 'QA',
    dial_code: '+974',
    currency_code: 'QAR',
    time_zones: ['Asia/Qatar'],
  },
  {
    name: 'Romania',
    flag: '🇷🇴',
    code: 'RO',
    dial_code: '+40',
    currency_code: 'RON',
    time_zones: ['Europe/Bucharest'],
  },
  {
    name: 'Russia',
    flag: '🇷🇺',
    code: 'RU',
    dial_code: '+7',
    currency_code: 'RUB',
    time_zones: [
      'Europe/Kaliningrad',
      'Europe/Moscow',
      'Europe/Volgograd',
      'Europe/Samara',
      'Asia/Yekaterinburg',
      'Asia/Omsk',
      'Asia/Novosibirsk',
      'Asia/Krasnoyarsk',
      'Asia/Irkutsk',
      'Asia/Yakutsk',
      'Asia/Vladivostok',
      'Asia/Srednekolymsk',
      'Asia/Kamchatka',
      'Asia/Anadyr',
    ],
  },
  {
    name: 'Rwanda',
    flag: '🇷🇼',
    code: 'RW',
    dial_code: '+250',
    currency_code: 'RWF',
    time_zones: ['Africa/Kigali'],
  },
  {
    name: 'Reunion',
    flag: '🇷🇪',
    code: 'RE',
    dial_code: '+262',
    currency_code: 'EUR',
    time_zones: ['Indian/Reunion'],
  },
  {
    name: 'Saint Barthelemy',
    flag: '🇧🇱',
    code: 'BL',
    dial_code: '+590',
    currency_code: 'EUR',
    time_zones: ['America/Guadeloupe'],
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    flag: '🇸🇭',
    code: 'SH',
    dial_code: '+290',
    currency_code: 'SHP',
    time_zones: ['Atlantic/St_Helena'],
  },
  {
    name: 'Saint Kitts and Nevis',
    flag: '🇰🇳',
    code: 'KN',
    dial_code: '+1869',
    currency_code: 'XCD',
    time_zones: ['America/St_Kitts'],
  },
  {
    name: 'Saint Lucia',
    flag: '🇱🇨',
    code: 'LC',
    dial_code: '+1758',
    currency_code: 'XCD',
    time_zones: ['America/St_Lucia'],
  },
  {
    name: 'Saint Martin',
    flag: '🇲🇫',
    code: 'MF',
    dial_code: '+590',
    currency_code: 'EUR',
    time_zones: ['America/Marigot'],
  },
  {
    name: 'Saint Pierre and Miquelon',
    flag: '🇵🇲',
    code: 'PM',
    dial_code: '+508',
    currency_code: 'EUR',
    time_zones: ['America/Miquelon'],
  },
  {
    name: 'Saint Vincent and the Grenadines',
    flag: '🇻🇨',
    code: 'VC',
    dial_code: '+1784',
    currency_code: 'XCD',
    time_zones: ['America/St_Vincent'],
  },
  {
    name: 'Samoa',
    flag: '🇼🇸',
    code: 'WS',
    dial_code: '+685',
    currency_code: 'WST',
    time_zones: ['Pacific/Apia'],
  },
  {
    name: 'San Marino',
    flag: '🇸🇲',
    code: 'SM',
    dial_code: '+378',
    currency_code: 'EUR',
    time_zones: ['Europe/San_Marino'],
  },
  {
    name: 'Sao Tome and Principe',
    flag: '🇸🇹',
    code: 'ST',
    dial_code: '+239',
    currency_code: 'STN',
    time_zones: ['Africa/Sao_Tome'],
  },
  {
    name: 'Saudi Arabia',
    flag: '🇸🇦',
    code: 'SA',
    dial_code: '+966',
    currency_code: 'SAR',
    time_zones: ['Asia/Riyadh'],
  },
  {
    name: 'Senegal',
    flag: '🇸🇳',
    code: 'SN',
    dial_code: '+221',
    currency_code: 'XOF',
    time_zones: ['Africa/Dakar'],
  },
  {
    name: 'Serbia',
    flag: '🇷🇸',
    code: 'RS',
    dial_code: '+381',
    currency_code: 'RSD',
    time_zones: ['Europe/Belgrade'],
  },
  {
    name: 'Seychelles',
    flag: '🇸🇨',
    code: 'SC',
    dial_code: '+248',
    currency_code: 'SCR',
    time_zones: ['Indian/Mahe'],
  },
  {
    name: 'Sierra Leone',
    flag: '🇸🇱',
    code: 'SL',
    dial_code: '+232',
    currency_code: 'SLL',
    time_zones: ['Africa/Freetown'],
  },
  {
    name: 'Singapore',
    flag: '🇸🇬',
    code: 'SG',
    dial_code: '+65',
    currency_code: 'SGD',
    time_zones: ['Asia/Singapore'],
  },
  {
    name: 'Slovakia',
    flag: '🇸🇰',
    code: 'SK',
    dial_code: '+421',
    currency_code: 'EUR',
    time_zones: ['Europe/Bratislava'],
  },
  {
    name: 'Slovenia',
    flag: '🇸🇮',
    code: 'SI',
    dial_code: '+386',
    currency_code: 'EUR',
    time_zones: ['Europe/Ljubljana'],
  },
  {
    name: 'Solomon Islands',
    flag: '🇸🇧',
    code: 'SB',
    dial_code: '+677',
    currency_code: 'SBD',
    time_zones: ['Pacific/Guadalcanal'],
  },
  {
    name: 'Somalia',
    flag: '🇸🇴',
    code: 'SO',
    dial_code: '+252',
    currency_code: 'SOS',
    time_zones: ['Africa/Mogadishu'],
  },
  {
    name: 'South Africa',
    flag: '🇿🇦',
    code: 'ZA',
    dial_code: '+27',
    currency_code: 'ZAR',
    time_zones: ['Africa/Johannesburg'],
  },
  {
    name: 'South Sudan',
    flag: '🇸🇸',
    code: 'SS',
    dial_code: '+211',
    currency_code: 'SSP',
    time_zones: ['Africa/Juba'],
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    flag: '🇬🇸',
    code: 'GS',
    dial_code: '+500',
    currency_code: 'GBP',
    time_zones: ['Atlantic/South_Georgia'],
  },
  {
    name: 'Spain',
    flag: '🇪🇸',
    code: 'ES',
    dial_code: '+34',
    currency_code: 'EUR',
    time_zones: ['Europe/Madrid', 'Atlantic/Canary'],
  },
  {
    name: 'Sri Lanka',
    flag: '🇱🇰',
    code: 'LK',
    dial_code: '+94',
    currency_code: 'LKR',
    time_zones: ['Asia/Colombo'],
  },
  {
    name: 'Sudan',
    flag: '🇸🇩',
    code: 'SD',
    dial_code: '+249',
    currency_code: 'SDG',
    time_zones: ['Africa/Khartoum'],
  },
  {
    name: 'Suriname',
    flag: '🇸🇷',
    code: 'SR',
    dial_code: '+597',
    currency_code: 'SRD',
    time_zones: ['America/Paramaribo'],
  },
  {
    name: 'Svalbard and Jan Mayen',
    flag: '🇸🇯',
    code: 'SJ',
    dial_code: '+47',
    currency_code: 'NOK',
    time_zones: ['Arctic/Longyearbyen'],
  },
  {
    name: 'Swaziland',
    flag: '🇸🇿',
    code: 'SZ',
    dial_code: '+268',
    currency_code: 'SZL',
    time_zones: ['Africa/Mbabane'],
  },
  {
    name: 'Sweden',
    flag: '🇸🇪',
    code: 'SE',
    dial_code: '+46',
    currency_code: 'SEK',
    time_zones: ['Europe/Stockholm'],
  },
  {
    name: 'Switzerland',
    flag: '🇨🇭',
    code: 'CH',
    dial_code: '+41',
    currency_code: 'CHF',
    time_zones: ['Europe/Zurich'],
  },
  {
    name: 'Syrian Arab Republic',
    flag: '🇸🇾',
    code: 'SY',
    dial_code: '+963',
    currency_code: 'SYP',
    time_zones: ['Asia/Damascus'],
  },
  {
    name: 'Taiwan',
    flag: '🇹🇼',
    code: 'TW',
    dial_code: '+886',
    currency_code: 'TWD',
    time_zones: ['Asia/Taipei'],
  },
  {
    name: 'Tajikistan',
    flag: '🇹🇯',
    code: 'TJ',
    dial_code: '+992',
    currency_code: 'TJS',
    time_zones: ['Asia/Dushanbe'],
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    flag: '🇹🇿',
    code: 'TZ',
    dial_code: '+255',
    currency_code: 'TZS',
    time_zones: ['Africa/Dar_es_Salaam'],
  },
  {
    name: 'Thailand',
    flag: '🇹🇭',
    code: 'TH',
    dial_code: '+66',
    currency_code: 'THB',
    time_zones: ['Asia/Bangkok'],
  },
  {
    name: 'Timor-Leste',
    flag: '🇹🇱',
    code: 'TL',
    dial_code: '+670',
    currency_code: 'USD',
    time_zones: ['Asia/Dili'],
  },
  {
    name: 'Togo',
    flag: '🇹🇬',
    code: 'TG',
    dial_code: '+228',
    currency_code: 'XOF',
    time_zones: ['Africa/Lome'],
  },
  {
    name: 'Tokelau',
    flag: '🇹🇰',
    code: 'TK',
    dial_code: '+690',
    currency_code: 'NZD',
    time_zones: ['Pacific/Fakaofo'],
  },
  {
    name: 'Tonga',
    flag: '🇹🇴',
    code: 'TO',
    dial_code: '+676',
    currency_code: 'TOP',
    time_zones: ['Pacific/Tongatapu'],
  },
  {
    name: 'Trinidad and Tobago',
    flag: '🇹🇹',
    code: 'TT',
    dial_code: '+1868',
    currency_code: 'TTD',
    time_zones: ['America/Port_of_Spain'],
  },
  {
    name: 'Tunisia',
    flag: '🇹🇳',
    code: 'TN',
    dial_code: '+216',
    currency_code: 'TND',
    time_zones: ['Africa/Tunis'],
  },
  {
    name: 'Turkey',
    flag: '🇹🇷',
    code: 'TR',
    dial_code: '+90',
    currency_code: 'TRY',
    time_zones: ['Europe/Istanbul'],
  },
  {
    name: 'Turkmenistan',
    flag: '🇹🇲',
    code: 'TM',
    dial_code: '+993',
    currency_code: 'TMT',
    time_zones: ['Asia/Ashgabat'],
  },
  {
    name: 'Turks and Caicos Islands',
    flag: '🇹🇨',
    code: 'TC',
    dial_code: '+1649',
    currency_code: 'USD',
    time_zones: ['America/Grand_Turk'],
  },
  {
    name: 'Tuvalu',
    flag: '🇹🇻',
    code: 'TV',
    dial_code: '+688',
    currency_code: 'AUD',
    time_zones: ['Pacific/Funafuti'],
  },
  {
    name: 'Uganda',
    flag: '🇺🇬',
    code: 'UG',
    dial_code: '+256',
    currency_code: 'UGX',
    time_zones: ['Africa/Kampala'],
  },
  {
    name: 'Ukraine',
    flag: '🇺🇦',
    code: 'UA',
    dial_code: '+380',
    currency_code: 'UAH',
    time_zones: ['Europe/Kiev', 'Europe/Uzhgorod', 'Europe/Simferopol'],
  },
  {
    name: 'United Arab Emirates',
    flag: '🇦🇪',
    code: 'AE',
    dial_code: '+971',
    currency_code: 'AED',
    time_zones: ['Asia/Dubai'],
  },
  {
    name: 'United Kingdom',
    flag: '🇬🇧',
    code: 'GB',
    dial_code: '+44',
    currency_code: 'GBP',
    time_zones: ['Europe/London'],
  },
  {
    name: 'United States',
    flag: '🇺🇸',
    code: 'US',
    dial_code: '+1',
    currency_code: 'USD',
    time_zones: [
      'America/New_York',
      'America/Chicago',
      'America/Denver',
      'America/Los_Angeles',
      'Pacific/Honolulu',
      'America/Anchorage',
    ],
  },
  {
    name: 'Uruguay',
    flag: '🇺🇾',
    code: 'UY',
    dial_code: '+598',
    currency_code: 'UYU',
    time_zones: ['America/Montevideo'],
  },
  {
    name: 'Uzbekistan',
    flag: '🇺🇿',
    code: 'UZ',
    dial_code: '+998',
    currency_code: 'UZS',
    time_zones: ['Asia/Tashkent'],
  },
  {
    name: 'Vanuatu',
    flag: '🇻🇺',
    code: 'VU',
    dial_code: '+678',
    currency_code: 'VUV',
    time_zones: ['Pacific/Efate'],
  },
  {
    name: 'Venezuela',
    flag: '🇻🇪',
    code: 'VE',
    dial_code: '+58',
    currency_code: 'VES',
    time_zones: ['America/Caracas'],
  },
  {
    name: 'Vietnam',
    flag: '🇻🇳',
    code: 'VN',
    dial_code: '+84',
    currency_code: 'VND',
    time_zones: ['Asia/Ho_Chi_Minh'],
  },
  {
    name: 'Virgin Islands, British',
    flag: '🇻🇬',
    code: 'VG',
    dial_code: '+1284',
    currency_code: 'USD',
    time_zones: ['America/Tortola'],
  },
  {
    name: 'Virgin Islands, U.S.',
    flag: '🇻🇮',
    code: 'VI',
    dial_code: '+1340',
    currency_code: 'USD',
    time_zones: ['America/St_Thomas'],
  },
  {
    name: 'Wallis and Futuna',
    flag: '🇼🇫',
    code: 'WF',
    dial_code: '+681',
    currency_code: 'XPF',
    time_zones: ['Pacific/Wallis', 'Pacific/Futuna'],
  },
  {
    name: 'Yemen',
    flag: '🇾🇪',
    code: 'YE',
    dial_code: '+967',
    currency_code: 'YER',
    time_zones: ['Asia/Aden'],
  },
  {
    name: 'Zambia',
    flag: '🇿🇲',
    code: 'ZM',
    dial_code: '+260',
    currency_code: 'ZMW',
    time_zones: ['Africa/Lusaka'],
  },
  {
    name: 'Zimbabwe',
    flag: '🇿🇼',
    code: 'ZW',
    dial_code: '+263',
    currency_code: 'ZWL',
    time_zones: ['Africa/Harare'],
  },
];

export const digitCounts: { [key: string]: number } = {
  // North America
  US: 10,
  CA: 10,
  MX: 10,

  // Central America & Caribbean
  GT: 8,
  BZ: 7,
  SV: 8,
  HN: 8,
  NI: 8,
  CR: 8,
  PA: 8,
  CU: 8,
  JM: 10,
  HT: 8,
  DO: 10,
  PR: 10,
  TT: 10,
  BB: 10,
  BS: 10,
  AG: 10,
  DM: 10,
  GD: 10,
  KN: 10,
  LC: 10,
  VC: 10,
  VG: 10,
  VI: 10,
  KY: 10,
  TC: 10,

  // South America
  BR: 11,
  AR: 10,
  CL: 9,
  CO: 10,
  PE: 9,
  VE: 10,
  EC: 9,
  BO: 8,
  PY: 9,
  UY: 9,
  GY: 7,
  SR: 7,
  GF: 9,

  // Western Europe
  GB: 10,
  UK: 10,
  DE: 11,
  FR: 9,
  IT: 10,
  ES: 9,
  PT: 9,
  NL: 9,
  BE: 9,
  AT: 10,
  CH: 9,
  LU: 9,
  IE: 9,
  MC: 8,
  LI: 7,
  AD: 6,
  SM: 10,
  VA: 10,

  // Northern Europe
  SE: 10,
  NO: 8,
  DK: 8,
  FI: 10,
  IS: 7,

  // Eastern Europe
  PL: 9,
  CZ: 9,
  SK: 9,
  HU: 9,
  RO: 10,
  BG: 9,
  SI: 9,
  HR: 9,
  BA: 8,
  RS: 9,
  ME: 8,
  MK: 8,
  AL: 9,
  GR: 10,
  CY: 8,
  MD: 8,
  BY: 9,
  UA: 9,
  LT: 8,
  LV: 8,
  EE: 8,
  XK: 8,

  // Russia & Central Asia
  RU: 10,
  KZ: 10,
  UZ: 9,
  TM: 8,
  KG: 9,
  TJ: 9,
  AM: 8,
  AZ: 9,
  GE: 9,

  // Middle East
  TR: 10,
  SA: 9,
  AE: 9,
  IL: 9,
  IQ: 10,
  IR: 10,
  JO: 9,
  LB: 8,
  SY: 9,
  YE: 9,
  OM: 8,
  KW: 8,
  BH: 8,
  QA: 8,
  PS: 9,

  // South Asia
  IN: 10,
  PK: 10,
  BD: 10,
  LK: 9,
  NP: 10,
  BT: 8,
  MV: 7,
  AF: 9,

  // Southeast Asia
  ID: 10,
  MY: 10,
  TH: 9,
  VN: 10,
  PH: 10,
  SG: 8,
  MM: 9,
  KH: 9,
  LA: 9,
  BN: 7,
  TL: 8,

  // East Asia
  CN: 11,
  JP: 10,
  KR: 10,
  KP: 10,
  TW: 9,
  HK: 8,
  MO: 8,
  MN: 8,

  // Oceania
  AU: 9,
  NZ: 9,
  PG: 8,
  FJ: 7,
  SB: 7,
  VU: 7,
  NC: 6,
  PF: 6,
  WS: 7,
  GU: 10,
  TO: 5,
  FM: 7,
  KI: 5,
  MH: 7,
  PW: 7,
  NR: 7,
  TV: 6,
  AS: 10,
  MP: 10,
  CK: 5,
  NU: 4,
  WF: 6,

  // North Africa
  EG: 10,
  DZ: 9,
  MA: 9,
  TN: 8,
  LY: 10,
  SD: 9,
  SS: 9,
  EH: 9,

  // West Africa
  NG: 10,
  GH: 9,
  CI: 10,
  SN: 9,
  ML: 8,
  BF: 8,
  NE: 8,
  GN: 9,
  SL: 8,
  LR: 8,
  TG: 8,
  BJ: 8,
  GM: 7,
  GW: 7,
  MR: 8,
  CV: 7,

  // East Africa
  KE: 10,
  TZ: 9,
  UG: 9,
  ET: 9,
  SO: 9,
  ER: 7,
  DJ: 8,
  RW: 9,
  BI: 8,
  SC: 7,
  MU: 8,
  KM: 7,
  MG: 9,
  RE: 10,
  YT: 9,

  // Central Africa
  CD: 9,
  CG: 9,
  CM: 9,
  CF: 8,
  TD: 8,
  GA: 8,
  GQ: 9,
  ST: 7,
  AO: 9,

  // Southern Africa
  ZA: 9,
  ZW: 9,
  ZM: 9,
  MW: 9,
  MZ: 9,
  BW: 8,
  NA: 9,
  LS: 8,
  SZ: 8,

  // Atlantic & Indian Ocean Territories
  GL: 6,
  FO: 6,
  SJ: 8,
  AX: 10,
  GI: 8,
  MT: 8,
  IM: 10,
  JE: 10,
  GG: 10,
  FK: 5,
  GS: 5,
  SH: 4,
  PM: 6,
  BM: 10,
  AW: 7,
  CW: 7,
  SX: 7,
  BQ: 7,
  AI: 10,
  MS: 10,
  IO: 7,
  CC: 9,
  CX: 9,
  NF: 6,
  HM: 9,
  AQ: 6,
  BV: 8,
  TF: 9,
};

export type CountryCode = (typeof COUNTRIES_DATA)[number]['code'];

export const mobileNumberDigitsLimits: { [key: string]: [number, number] } = {
  // North America
  US: [10, 10],
  CA: [10, 10],
  MX: [10, 10],

  // Central America & Caribbean
  GT: [8, 8],
  BZ: [7, 7],
  SV: [8, 8],
  HN: [8, 8],
  NI: [8, 8],
  CR: [8, 8],
  PA: [8, 8],
  CU: [8, 8],
  JM: [10, 10],
  HT: [8, 8],
  DO: [10, 10],
  PR: [10, 10],
  TT: [10, 10],
  BB: [10, 10],
  BS: [10, 10],
  AG: [10, 10],
  DM: [10, 10],
  GD: [10, 10],
  KN: [10, 10],
  LC: [10, 10],
  VC: [10, 10],
  VG: [10, 10],
  VI: [10, 10],
  KY: [10, 10],
  TC: [10, 10],

  // South America
  BR: [11, 11],
  AR: [10, 10],
  CL: [9, 9],
  CO: [10, 10],
  PE: [9, 9],
  VE: [10, 10],
  EC: [9, 9],
  BO: [8, 8],
  PY: [9, 9],
  UY: [9, 9],
  GY: [7, 7],
  SR: [7, 7],
  GF: [9, 9],

  // Western Europe
  GB: [10, 10],
  UK: [10, 10],
  DE: [10, 11],
  FR: [9, 9],
  IT: [9, 10],
  ES: [9, 9],
  PT: [9, 9],
  NL: [9, 9],
  BE: [8, 9],
  AT: [10, 10],
  CH: [9, 9],
  LU: [9, 9],
  IE: [9, 9],
  MC: [8, 8],
  LI: [7, 7],
  AD: [6, 6],
  SM: [10, 10],
  VA: [10, 10],

  // Northern Europe
  SE: [9, 10],
  NO: [8, 8],
  DK: [8, 8],
  FI: [9, 10],
  IS: [7, 7],

  // Eastern Europe
  PL: [9, 9],
  CZ: [9, 9],
  SK: [9, 9],
  HU: [9, 9],
  RO: [10, 10],
  BG: [9, 9],
  SI: [8, 9],
  HR: [8, 9],
  BA: [8, 8],
  RS: [9, 9],
  ME: [8, 8],
  MK: [8, 8],
  AL: [9, 9],
  GR: [10, 10],
  CY: [8, 8],
  MD: [8, 8],
  BY: [9, 9],
  UA: [9, 9],
  LT: [8, 8],
  LV: [8, 8],
  EE: [7, 8],
  XK: [8, 8],

  // Russia & Central Asia
  RU: [10, 10],
  KZ: [10, 10],
  UZ: [9, 9],
  TM: [8, 8],
  KG: [9, 9],
  TJ: [9, 9],
  AM: [8, 8],
  AZ: [9, 9],
  GE: [9, 9],

  // Middle East
  TR: [10, 10],
  SA: [9, 9],
  AE: [9, 9],
  IL: [9, 9],
  IQ: [10, 10],
  IR: [10, 10],
  JO: [9, 9],
  LB: [8, 8],
  SY: [9, 9],
  YE: [9, 9],
  OM: [8, 8],
  KW: [8, 8],
  BH: [8, 8],
  QA: [8, 8],
  PS: [9, 9],

  // South Asia
  IN: [10, 10],
  PK: [10, 10],
  BD: [10, 10],
  LK: [9, 9],
  NP: [10, 10],
  BT: [8, 8],
  MV: [7, 7],
  AF: [9, 9],

  // Southeast Asia
  ID: [9, 11],
  MY: [9, 10],
  TH: [9, 9],
  VN: [9, 10],
  PH: [10, 10],
  SG: [8, 8],
  MM: [9, 10],
  KH: [8, 9],
  LA: [8, 9],
  BN: [7, 7],
  TL: [8, 8],

  // East Asia
  CN: [11, 11],
  JP: [10, 10],
  KR: [9, 10],
  KP: [10, 10],
  TW: [9, 10],
  HK: [8, 8],
  MO: [8, 8],
  MN: [8, 8],

  // Oceania
  AU: [9, 9],
  NZ: [8, 9],
  PG: [8, 8],
  FJ: [7, 7],
  SB: [7, 7],
  VU: [7, 7],
  NC: [6, 6],
  PF: [6, 6],
  WS: [7, 7],
  GU: [10, 10],
  TO: [5, 5],
  FM: [7, 7],
  KI: [5, 5],
  MH: [7, 7],
  PW: [7, 7],
  NR: [7, 7],
  TV: [6, 6],
  AS: [10, 10],
  MP: [10, 10],
  CK: [5, 5],
  NU: [4, 4],
  WF: [6, 6],

  // North Africa
  EG: [10, 10],
  DZ: [9, 9],
  MA: [9, 9],
  TN: [8, 8],
  LY: [9, 10],
  SD: [9, 9],
  SS: [9, 9],
  EH: [9, 9],

  // West Africa
  NG: [10, 10],
  GH: [9, 9],
  CI: [10, 10],
  SN: [9, 9],
  ML: [8, 8],
  BF: [8, 8],
  NE: [8, 8],
  GN: [9, 9],
  SL: [8, 8],
  LR: [8, 8],
  TG: [8, 8],
  BJ: [8, 8],
  GM: [7, 7],
  GW: [7, 7],
  MR: [8, 8],
  CV: [7, 7],

  // East Africa
  KE: [9, 10],
  TZ: [9, 9],
  UG: [9, 9],
  ET: [9, 9],
  SO: [9, 9],
  ER: [7, 7],
  DJ: [8, 8],
  RW: [9, 9],
  BI: [8, 8],
  SC: [7, 7],
  MU: [8, 8],
  KM: [7, 7],
  MG: [9, 9],
  RE: [10, 10],
  YT: [9, 9],

  // Central Africa
  CD: [9, 9],
  CG: [9, 9],
  CM: [9, 9],
  CF: [8, 8],
  TD: [8, 8],
  GA: [8, 8],
  GQ: [9, 9],
  ST: [7, 7],
  AO: [9, 9],

  // Southern Africa
  ZA: [9, 9],
  ZW: [9, 9],
  ZM: [9, 9],
  MW: [9, 9],
  MZ: [9, 9],
  BW: [8, 8],
  NA: [9, 9],
  LS: [8, 8],
  SZ: [8, 8],

  // Atlantic & Indian Ocean Territories
  GL: [6, 6],
  FO: [6, 6],
  SJ: [8, 8],
  AX: [10, 10],
  GI: [8, 8],
  MT: [8, 8],
  IM: [10, 10],
  JE: [10, 10],
  GG: [10, 10],
  FK: [5, 5],
  GS: [5, 5],
  SH: [4, 4],
  PM: [6, 6],
  BM: [10, 10],
  AW: [7, 7],
  CW: [7, 7],
  SX: [7, 7],
  BQ: [7, 7],
  AI: [10, 10],
  MS: [10, 10],
  IO: [7, 7],
  CC: [9, 9],
  CX: [9, 9],
  NF: [6, 6],
  HM: [9, 9],
  AQ: [6, 6],
  BV: [8, 8],
  TF: [9, 9],
};
